__turbopack_context__.v({
  "googleButton": "styles-module__fQXfGa__googleButton",
});
